import { render, staticRenderFns } from "./ModalWebApp.vue?vue&type=template&id=5643b39e&"
import script from "./ModalWebApp.vue?vue&type=script&lang=js&"
export * from "./ModalWebApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports